var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgApprovalRequired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 0C55.965 0 0 55.965 0 125C0 194.035 55.965 250 125 250C194.035 250 250 194.035 250 125C250 55.965 194.035 0 125 0Z",
    fill: "#54C0EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190 70H207.5C213.022 70 217.5 74.48 217.5 80V97.5C217.5 103.022 213.022 107.5 207.5 107.5H190C184.477 107.5 180 103.022 180 97.5V80C180 74.4775 184.477 70 190 70Z",
    fill: "#CCD0D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.5 80C197.5 74.4775 201.977 70 207.5 70H52.5C47.3475 70 42.5 74.8875 42.5 80V218.867C64.515 238.232 93.375 250 125 250C152.037 250 177.048 241.388 197.5 226.795V80Z",
    fill: "#F3F3F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.75 132.5H90.25C88.18 132.5 86.5 134.18 86.5 136.25C86.5 138.32 88.18 140 90.25 140H173.75C175.82 140 177.5 138.32 177.5 136.25C177.5 134.18 175.82 132.5 173.75 132.5ZM173.75 159.5H90.25C88.18 159.5 86.5 161.18 86.5 163.25C86.5 165.32 88.18 167 90.25 167H173.75C175.82 167 177.5 165.32 177.5 163.25C177.5 161.18 175.82 159.5 173.75 159.5ZM173.75 185H90.25C88.18 185 86.5 186.68 86.5 188.75C86.5 190.82 88.18 192.5 90.25 192.5H173.75C175.82 192.5 177.5 190.82 177.5 188.75C177.5 186.68 175.82 185 173.75 185ZM65.75 105H95.75C97.82 105 99.5 103.32 99.5 101.25C99.5 99.18 97.82 97.5 95.75 97.5H65.75C63.68 97.5 62 99.18 62 101.25C62 103.32 63.68 105 65.75 105ZM141.25 210.497H90.25C88.18 210.497 86.5 212.18 86.5 214.25C86.5 216.32 88.18 218 90.25 218H141.25C143.32 218 145 216.32 145 214.25C145 212.18 143.32 210.497 141.25 210.497Z",
    fill: "#CCD0D2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 136.5,
    r: 8.5,
    fill: "#13C1BF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 162.5,
    r: 6.5,
    stroke: "#CCD0D2",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 188.5,
    r: 6.5,
    stroke: "#CCD0D2",
    strokeWidth: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 214.5,
    r: 6.5,
    stroke: "#CCD0D2",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2596 142H69.2589L65 137.6L66.9415 135.597L69.2589 137.991L75.0592 132L77 134.005L69.2596 142Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgApprovalRequired);
export default __webpack_public_path__ + "static/media/img_approval_required.9acf8baf41d5995ed6691e2906ac1e8f.svg";
export { ForwardRef as ReactComponent };